{
  "/urlPrefix": "/data-analytics-services",
  "/aboutdas": "/aboutdas",
  "/aaw": "/aaw",
  "/cae": "/cae",
  "/faq": "/faq",
  "/gae": "/gae",
  "/hub": "/hub",
  "/overview": "/overview",
  "/pricing": "/pricing",
  "/termsAndConditions": "/terms-and-conditions",
  "/vdlHub": "/vdl-hub",

  "aaw": "Advanced Analytics Workspace",
  "aawAcronym": "AAW",
  "aawDash": "AAW dashboard",
  "aawDashboard": "Advanced Analytics Workspace Dashboard",
  "about": "About",
  "aboutCanadaCa": "About Canada.ca",
  "aboutGov": "About government",
  "aboutSite": "About this site",
  "account": "Account",
  "active": "active",
  "azureAccount": "Azure Account",
  "azureLearningGuide": "Azure learning guide",
  "cae": "Collaborative Analytics Environment",
  "caeAcronym": "CAE",
  "caeDash": "CAE dashboard",
  "caeDashBoard": "Collaborative Analytics Environment Dashboard",
  "cancel": "Cancel",
  "contactEmail": "Contact email",
  "contactUs": "Contact us",
  "dasToolsAndGuides": "DAS tools and guides",
  "dateMod": "Date modified",
  "departments": "Departments and agencies",
  "documentation": "Documentation",
  "environments": "Environments",
  "faq": "Frequently asked questions (FAQ)",
  "gae": "Geospatial Analytics Environment",
  "gaeAcronym": "GAE",
  "gaeDash": "GAE dashboard",
  "gaeDashBoard": "Geospatial Analytics Environment Dashboard",
  "getStarted": "Get started",
  "canadaLogo": "Symbol of the Government of Canada",
  "close": "Close",
  "daaas": "Data Analytics Services",
  "daaasAcronym": "DAS",
  "daaasBreadCrumb": "About DAS",
  "daaasBreadCrumbCanadaca": "You are here:",
  "dasTools": "DAS gives you access to the tools listed below and allows you to customize your experience based on your needs. The tools can be used in three distinct work environments, each designed to support different types of projects. Once you have started a project with DAS, you can access the associated tools directly from this hub.",
  "dashboard": "dashboard",
  "feedback": "Feedback",
  "freepik": "Freepik",
  "help": "Help",
  "home": "Home",
  "howGovWorks": "How government works",
  "hrefMsFormsGetStarted": "https://forms.office.com/pages/responsepage.aspx?id=mR-PJT3ux0K_xXrxsjQ-ApbSRgATuERFkV3XLiwQ8xFUQ1NHRzBVWEFYUktZRzBJRDIwUDZFSDQ0USQlQCN0PWcu",
  "hrefStatcanLicence": "https://www.statcan.gc.ca/en/reference/licence",
  "hrefStatcanPrivacy": "https://www.statcan.gc.ca/en/reference/privacy",
  "hrefStatcanStart": "https://www.statcan.gc.ca/en/start",
  "hrefStatcanTermsConditions": "https://www.statcan.gc.ca/en/reference/terms-conditions",
  "hub": "Hub",
  "hubInfoText": "Please note that at this time, some open source and statistical software tools may not be available for use in both official languages. Statistics Canada is working to ensure that all available data products and tools in the DAS platform will be accessible in both official languages in the near future. For more information, visit the several guides below.",
  "illustBy": "Illustrations by",
  "langSelection": "Language selection",
  "lastMod": "Last modified on",
  "loading": "Loading",
  "main": "Main",
  "menu": "Menu",
  "mobileApps": "Mobile applications",
  "myHub": "DAS Hub",
  "news": "News",
  "newTab": "Opens in a new tab",
  "openGov": "Open government",
  "overview": "Overview",
  "primeMinister": "Prime Minister",
  "privacy": "Privacy",
  "profile": "Profile",
  "protectedB": "Protected B",
  "publicService": "Public service and military",
  "reporting": "Government-wide reporting",
  "signIn": "Sign in",
  "signOut": "Sign out",
  "skipFooter": "Skip to footer",
  "skipMain": "Skip to main content",
  "socialMedia": "Social media",
  "startaProject": "Start a new project",
  "statCan": "Statistics Canada",
  "terms": "Terms and conditions",
  "toGetStarted": "To get started, click on 'Start a new project' and fill out the form to tell us about your project needs. Once completed, a DAS representative will contact you to discuss the next steps and begin the onboarding process.",
  "topOfPage": "Top of page",
  "trainingResources": "Training Resources",
  "dctermsCreator": "Government of Canada, Statistics Canada",
  "dctermsLanguage": "eng",
  "dctermsSubject": "none",
  "vdlHub": "vDL Hub"
}
